import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { intercept, observable, computed } from 'mobx';
import { CollectionComponent } from './collection.component';
import { CollectionCarousel } from './collection.carousel';
import { CollectionAbout } from './collection.about';

import './collection.scss';

let classNames = require('classnames');

@inject('appStore', 'routerStore')
@observer
export class CollectionProvider extends Component {

    @observable collection;

    componentWillMount() {
        const { appStore } = this.props;
        this.getCollection(appStore.collections);

        // watch for changes in appstore.collections
        this.disposeCollections = intercept(appStore, 'collections', (change) => {
            if (change.newValue) {
                this.getCollection(change.newValue);
            }
            return change;
        });

        if (this.props.match.params.artwork === 'about') {
            appStore.aboutOpen = true;
        } else if (!this.props.match.params.artwork) {
            let zoomState = {
                left: '-100%',
                top: '-100%',
                open: false
            };
            appStore.zoomState = zoomState;
        }
    }

    componentWillUnmount() {
        this.disposeCollections();
    }

    getCollection(collections) {
        const { appStore } = this.props,
            URLSegment = this.props.match.params['collection'];
        if (URLSegment && collections.length) {
            if (appStore.expCollectionID) {
                // appStore would have fetched by id, so use the first collection
                this.collection = collections[0];
            }
            this.collection = this.getCollectionByUrlSegment(collections, URLSegment);
            appStore.collection = this.collection;
        }
    }

    @computed get artwork() {
        const URLSegment = this.props.match.params['artwork'];
        if (URLSegment && this.collection && this.collection.Artwork) {
            let artwork = this.getArtworkByUrlSegment(URLSegment);
            if (artwork) {
                return artwork;
            }
        }
    }

    /**
     * get a collection by its URLSegment
     */
    getCollectionByUrlSegment(collections, URLSegment) {
        return collections.find(
            item => item.URLSegment === URLSegment
        );
    }

    /**
     * get a artwork by its URLSegment
     */
    getArtworkByUrlSegment(URLSegment) {
        return this.collection.Artwork.find(
            item => item.URLSegment === URLSegment
        );
    }

    /**
     * close carousel
     */
    closeCarousel() {
        const { appStore, routerStore } = this.props,
            zoomState = {
                left: '-100%',
                top: '-100%',
                scaleX: 1,
                scaleY: 1,
                open: false
            };
        appStore.zoomState = zoomState;
        appStore.carouselOpen = false;

        // ensure all content is scrollTop 0
        let elements = document.getElementsByClassName('artwork-content');
        if (elements.length) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].scrollTop = 0;
            }
        }

        if (this.collection) {
            routerStore.history.push(this.collection.Link);
        } else {
            routerStore.history.push('/');
        }
    }

    getZoom() {
        const { appStore } = this.props;

        let pre = this.props.match.params.artwork && this.props.match.params.artwork !== 'about',
            transform = appStore.zoomState.scaleX === 1 ? 'none' : `scaleX(${appStore.zoomState.scaleX}) scaleY(${appStore.zoomState.scaleY})`,
            zoomClasses = classNames({
                'carousel-zoom': true,
                'carousel-zoom--pre': pre,
                'carousel-zoom--open': pre && appStore.zoomState.open
            }),
            zoomStyle = {
                opacity: appStore.zoomState.opacity,
                top: appStore.zoomState.top,
                left: appStore.zoomState.left,
                transform: transform
            };

        if (!this.props.match.params.artwork) {
            zoomStyle = {
                left: '-100%',
                top: '-100%',
                scaleX: 1,
                scaleY: 1,
                open: false
            };
        }

        return <div className={zoomClasses} style={zoomStyle} />;
    }

    getCarousel() {
        const open = this.props.match.params.artwork && this.props.match.params.artwork !== 'about',
            carouselClasses = classNames({
                'carousel-holder': true,
                'carousel-holder--open': open
            });

        return <div className={carouselClasses}>
            <button className='pure-button pure-button--close' onClick={e => this.closeCarousel()}>
                Close
            </button>
            <CollectionCarousel
                key='carousel'
                collection={this.collection}
                currentSlide={this.artwork ? parseInt(this.artwork.Pos, 10) : 0}
                sliderOpen={this.artwork}
            />
        </div>;
    }

    getAboutContent() {
        const open = this.props.match.params.artwork && this.props.match.params.artwork === 'about';
        return (
            this.collection && this.collection.EnableAboutContent && <CollectionAbout
                collection={this.collection} open={open}
            />
        );
    }

    render() {
        return <div>
            <CollectionComponent key='collection' collection={this.collection} />
            {this.getZoom()}
            {this.getCarousel()}
            {this.getAboutContent()}
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_collection/collection.provider.js